export var GraphSortField;
(function (GraphSortField) {
    GraphSortField["GRAPH_SORT_FIELD_CREATED_AT"] = "createdAt";
    GraphSortField["GRAPH_SORT_FIELD_UPDATED_AT"] = "updatedAt";
    GraphSortField["GRAPH_SORT_FIELD_TITLE"] = "title";
})(GraphSortField || (GraphSortField = {}));
